class Reassurance extends HTMLElement {
    constructor() {
        super();

        if (this.querySelector('.swiper-reassurance')) {
            const swiper = new Swiper(this.querySelector('.swiper-reassurance'), {
                // Optional parameters
                direction: 'horizontal',
                slidesPerView: 1,
                loop: true,
                spaceBetween: 10,
                mousewheel: {
                    invert: false,
                    forceToAxis: true,
                },
                breakpoints: {
                    749: {
                        slidesPerView: 2,
                    },
                    990: {
                        slidesPerView: 3,
                    }
                },

                navigation: {
                    nextEl: this.querySelector('.swiper-button-next'),
                    prevEl: this.querySelector('.swiper-button-prev'),
                },


            });
        }
    }
}

customElements.define('reassu-rance', Reassurance);